module.exports = __webpack_public_path__ + "static/media/more.57d3dead.svg";